import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 0 24px;
`;

export const HeaderCompanyCard = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 84px;
  min-width: 320px;
  flex: 1;
  padding: 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const CompanyAvatar = styled.img`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  object-fit: cover;
`;

export const CompanyAvatarFallback = styled.div`
  ${TypographyV2.b1};
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${ColorV2.Blue6};
  color: ${ColorV2.Blue1};
`;

export const CompanyMetaColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 4px;
`;

export const CompanyName = styled.span`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const CompanyMeta = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SectionTitle = styled.div`
  ${TypographyV2.b1};
  color: ${ColorV2.Blue1};
`;

export const SectionSubTitle = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(260px, 2.4fr) minmax(130px, 0.9fr) minmax(95px, 0.8fr) minmax(95px, 0.8fr) minmax(110px, 1fr);
  align-items: center;
  column-gap: 8px;
  padding: 14px 12px;
  border-radius: 12px;
  background: ${ColorV2.Blue7};

  > :nth-child(2),
  > :nth-child(3),
  > :nth-child(4) {
    margin-left: 56px;
  }
`;

export const Person = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const PersonName = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue1};
`;

export const PersonMeta = styled.div`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CellLabel = styled.span<{ $muted?: boolean }>`
  ${TypographyV2.s1};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue4)};
`;

export const CellValue = styled.span<{ $muted?: boolean }>`
  ${TypographyV2.b2};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue1)};
`;

export const StatusPill = styled.span<{ $tone: "success" | "warning" | "neutral" }>`
  ${TypographyV2.s1};
  justify-self: end;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 999px;
  background: ${(props) =>
    props.$tone === "success"
      ? "#DCF6E8"
      : props.$tone === "warning"
        ? "#FFECC6"
        : ColorV2.Blue6};
  color: ${(props) =>
    props.$tone === "success"
      ? "#127A4E"
      : props.$tone === "warning"
        ? "#9B6A00"
        : ColorV2.Blue2};
`;

export const Message = styled.div`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue4};
  padding: 20px 8px;
`;
